/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { MICROSOFT, DAYS_OF_THE_WEEK } from 'utils/constants';
import LanguageIcon from '@material-ui/icons/Language';
import { unionBy } from 'lodash-es';

// eslint-disable-next-line import/prefer-default-export
export const getPlaceNetworkContent = (place, client) => {
  const { coeVendor: { coeVendorName } = {} } = place;

  const networkContent = {
    networkText: 'In Network',
    showTooltip: false,
    getIcon: (palette) => (
      <LanguageIcon color="inherit" fontSize="inherit" htmlColor={palette.success.dark} />
    ),
    showNetworkStatus: true,
  };

  // Microsoft
  if (client === MICROSOFT) {
    networkContent.showNetworkStatus = false;
  }

  if (coeVendorName) {
    networkContent.networkText = `${coeVendorName} Network`;
    networkContent.tooltipMessage = `This facility has been designated as a COE Network facility by ${coeVendorName}. A COE (Center of Excellence) is a healthcare center known for providing top-quality care for certain health conditions.`;
  }

  return networkContent;
};

export const normalizeHOR = (hor) => {
  const normalizedDays = [];
  const today = new Date();

  for (const day of hor) {
    if (DAYS_OF_THE_WEEK[day.dayOfWeek]) {
      const formattedDay = { ...DAYS_OF_THE_WEEK[day.dayOfWeek] };
      normalizedDays.push(Object.assign({}, formattedDay, ...day.hours));
    }
  }

  // convert time into non-military time
  normalizedDays.forEach((day) => {
    day.openingTime = new Date(`${today.getMonth()} ${day.openingTime}`).toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    });
    day.closingTime = new Date(`${today.getMonth()} ${day.closingTime}`).toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    });

    if (day.openingTime[0] === '0') {
      day.openingTime = day.openingTime.slice(1);
    }

    if (day.closingTime[0] === '0') {
      day.closingTime = day.closingTime.slice(1);
    }

    if (day.openingTime.includes(':00')) {
      day.openingTime = day.openingTime.replace(/:00/gi, '');
    }

    if (day.closingTime.includes(':00')) {
      day.closingTime = day.closingTime.replace(/:00/gi, '');
    }
  });
  const mergedNormalizedDays = unionBy(normalizedDays, Object.values(DAYS_OF_THE_WEEK), 'order');
  return mergedNormalizedDays.sort((a, b) => a.order - b.order);
};

export const formatBusinessHours = (scheduleArray, currentDay) => {
  if (!scheduleArray) return null;

  const lines = scheduleArray.map((entry) => {
    const { day, openingTime, closingTime } = entry;

    let formattedTime =
      openingTime === 'Closed'
        ? `${day}: ${openingTime}`
        : `${day}: ${openingTime} - ${closingTime}`;

    if (day === currentDay?.day) {
      formattedTime = `**${formattedTime}**`;
    }

    return `${formattedTime}  \n`;
  });

  return lines.join('');
};
